// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2TdO-"};